import { useEffect, useState } from "react";
import DynamicText from "./DynamicText.tsx";
import LinkHandler from "./LinkHandler.tsx";
import axios from "axios";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import { Environment as environment } from "../../environment.ts";

interface Attribute {
    attributeId: string;
    attributeName: string;
    businessId: string;
}

const AskMedia = (data) => {

    const [question, setQuestion] = useState<string>("");
    const [attributes, setAttributes] = useState<Attribute[]>([]);
    const [mediaType, setMediaType] = useState<string>("ANY");
    const [attribute, setAttribute] = useState<string>("");
    const [noOfAttempts, setNoOfAttempts] = useState<number>(0);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const { nodes, setNodes, businessId } = useFlowStore();

    const getAllAtributes = () => {
        const payload = {
            businessId: businessId,
            page: 0,
            size: 100
        }
        axios.put(`${environment.baseUrl}/fetch/attribute`, payload).then((response) => {
            setAttributes(response.data.data.data);
            setAttribute(response.data.data.data[0].attributeName);
        }).catch((error) => { });
    }

    useEffect(() => {
        getAllAtributes();
    }, []);

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as any;
                setQuestion(d.text || "");
                setAttribute(d.attribute || d.attributeFormat || "");
                setMediaType(d.mediaType || "ANY");
                setNoOfAttempts(d.attributeNumberOfAttempt ?? 0);
                setErrorMessage(d.attributeFormatValidationErrorMessage || "");
            }
        }
    }, []);

    useEffect(() => {
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        attribute: attribute,
                                        attributeNumberOfAttempt: noOfAttempts,
                                        text: question,
                                        mediaType: mediaType,
                                        attributeFormatValidationErrorMessage: errorMessage
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [question, attribute, mediaType, noOfAttempts, errorMessage]);


    return (
        <div className="node-body">
            <div>
                <span className="font-label">Question</span>
                <DynamicText
                    placeholder="Type Question.."
                    value={question}
                    setValue={(val) => setQuestion(val)}
                    maxLength={1024}
                />
            </div>
            <div>
                <span className="font-label">Capture answer attribute</span>
                <select value={attribute} onChange={(event) => setAttribute(event.target.value)}>
                    {
                        attributes.map((attr) => {
                            return (<option value={attr.attributeName}>{attr.attributeName}</option>)
                        })
                    }
                </select>
            </div>
            <div>
                <span className="font-label">Media Type</span>
                <select value={mediaType} onChange={(event) => setMediaType(event.target.value)}>
                    <option value="ANY">Any</option>
                    <option value="IMAGE">Image</option>
                    <option value="VIDEO">Video</option>
                    <option value="DOCUMENT">Document</option>
                </select>
            </div>
            <div>
                <span className="font-label">Number of attempt</span>
                <input
                    type="number"
                    placeholder="Number of attempts"
                    min={1}
                    value={noOfAttempts}
                    onChange={(event) => setNoOfAttempts(parseInt(event.target.value))}
                />
            </div>
            <div>
                <span className="font-label">Enter Validation error message</span>
                <DynamicText
                    placeholder="Error message"
                    value={errorMessage}
                    maxLength={72}
                    setValue={(val) => setErrorMessage(val)}
                />
            </div>
            <LinkHandler />
        </div>
    )
}

export default AskMedia;
